import { X } from 'lucide-react'
import React, { useContext, useState } from 'react'
import { BASE_URL_API } from '../../References/URLs'
import ActiveStoreContext from '../../store/ActiveStoreContext'
import AuthContext from '../../store/auth-context'
import styles from './AddWalletMoneyModal.module.css'

const QUICK_AMOUNTS = [500, 1000, 2000, 5000]

// Marks this top-up as not tied to any campaign — the payment gateway return
// URL for a normal campaign top-up carries campaignIdentifier as udf3; this
// screen has no campaign in context, so it sends this instead and expects the
// backend to redirect back to /communications/store-wallet/:paymentStatus/:txnId.
const WALLET_TOPUP_MARKER = 'WALLET_TOPUP'

const AddWalletMoneyModal = ({ isOpen, onClose, currentBalance }) => {
    const authCtx = useContext(AuthContext)
    const asCtx = useContext(ActiveStoreContext)
    const activeStore = (() => {
        try { return (asCtx?.activeStore && asCtx.activeStore.trim() !== "") ? JSON.parse(asCtx.activeStore) : null }
        catch { return null }
    })()
    const welcomeData = JSON.parse(authCtx?.loginData ?? 'null')?.welcomeData

    const [amount, setAmount] = useState('')
    const [error, setError] = useState('')
    const [submitting, setSubmitting] = useState(false)

    if (!isOpen) return null

    const handleClose = () => {
        if (submitting) return
        setAmount('')
        setError('')
        onClose()
    }

    const handleAddNow = () => {
        const numAmount = parseFloat(amount)
        if (isNaN(numAmount) || numAmount <= 0) {
            setError('Enter a valid amount to add.')
            return
        }
        setSubmitting(true)

        const form = document.createElement('form')
        form.method = 'POST'
        form.action = BASE_URL_API + 'getPayment.php'

        const data = {
            token: authCtx.token,
            firstName: welcomeData?.displayName,
            lastName: welcomeData?.role,
            email: '',
            productinfo: 'Wallet Balance',
            phone: activeStore?.storePrimaryPhone,
            address1: activeStore?.storeAddress,
            city: 'city received',
            state: 'state received',
            country: '',
            zipcode: 'pincode received',
            udf1: activeStore?.storeIdentifier,
            udf2: JSON.parse(authCtx?.loginData ?? 'null')?.partnersData?.vendorIdentifier,
            udf3: WALLET_TOPUP_MARKER,
            amount: numAmount
        }

        Object.entries(data).forEach(([key, value]) => {
            const input = document.createElement('input')
            input.type = 'hidden'
            input.name = key
            input.value = value
            form.appendChild(input)
        })

        document.body.appendChild(form)
        form.submit()
    }

    return (
        <div className={styles.backdrop} onClick={handleClose}>
            <div className={styles.modal} onClick={e => e.stopPropagation()}>
                <div className={styles.header}>
                    <span className={styles.title}>Add money to wallet</span>
                    <button className={styles.closeBtn} onClick={handleClose} type="button" disabled={submitting}>
                        <X size={15} />
                    </button>
                </div>
                <div className={styles.body}>
                    <div className={styles.balanceLine}>
                        Current balance <strong>₹{Number(currentBalance || 0).toLocaleString('en-IN')}</strong>
                    </div>
                    <div className={styles.quickAmounts}>
                        {QUICK_AMOUNTS.map(q => (
                            <button
                                key={q}
                                type="button"
                                className={`${styles.quickBtn} ${Number(amount) === q ? styles.quickBtnActive : ''}`}
                                onClick={() => { setAmount(String(q)); setError('') }}
                                disabled={submitting}
                            >
                                ₹{q.toLocaleString('en-IN')}
                            </button>
                        ))}
                    </div>
                    <input
                        className={styles.amountInput}
                        type="number"
                        min="1"
                        placeholder="Or enter a custom amount"
                        value={amount}
                        onChange={e => { setAmount(e.target.value); setError('') }}
                        disabled={submitting}
                        autoFocus
                    />
                    {error && <div className={styles.errorText}>{error}</div>}
                </div>
                <div className={styles.footer}>
                    <button className={styles.cancelBtn} onClick={handleClose} type="button" disabled={submitting}>
                        Cancel
                    </button>
                    <button className={styles.payBtn} onClick={handleAddNow} type="button" disabled={submitting}>
                        {submitting ? 'Redirecting…' : 'Proceed to pay'}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default AddWalletMoneyModal
